import ReactDOM from 'react-dom';
import React from 'react';
import { getJSONFromHtml } from '../../domain/common';
import CommonProductGallery from '../common-product-gallery/common-product-gallery';
import { ICommonGallery } from '../common-product-gallery/interfaces';
import { sendInitialAnalytics } from '../common-product-gallery/data-services/data-service';
import { IListItem } from '../list-page/interfaces/interfaces';

export const getGalleryProperties = ($gallery: HTMLElement) : ICommonGallery => {

    // get gallery properties
    const dataID = $gallery.getAttribute('data-id');
    const dataType = $gallery.getAttribute('data-type');
    const dataPageType = $gallery.getAttribute('data-page-type');
    const dataTab = $gallery.getAttribute('data-tab');
    const listName = $gallery.getAttribute('data-list-name');
    const useBuiltInTitle = $gallery.getAttribute('data-use-built-in-title');
    const dataCustomTitle = $gallery.getAttribute('data-custom-title-text');
    const dataCustomTitleCss = $gallery.getAttribute('data-custom-title-css');
    const dataCustomSubTitle = $gallery.getAttribute('data-custom-sub-title-text');
    const isButtonAndNoteHidden = $gallery.getAttribute('data-hide-button-note');
    const isPriceFirstRowHidden = $gallery.getAttribute('data-hide-first-row');
    const isPriceSecondRowHidden = $gallery.getAttribute('data-hide-second-row');
    const isPriceThirdRowHidden = $gallery.getAttribute('data-hide-third-row');
    const isFirstMerchRowHidden = $gallery.getAttribute('data-hide-first-merch-row');
    const isPriceDiscountBadgeHidden = $gallery.getAttribute('data-hide-discount-badge');
    const isExpectedShippingHidden = $gallery.getAttribute('data-hide-expected-shipping');
    const isTaglineHidden = $gallery.getAttribute('data-hide-tagline');
    const isClockHidden = $gallery.getAttribute('data-hide-clock');
    const numberOfRowsShown = $gallery.getAttribute('data-rows-shown');
    const showMoreLess = $gallery.getAttribute('data-more-less');
    const isDataExplore = $gallery.getAttribute('data-explore');
    const isRemoveImgLink = $gallery.getAttribute('data-remove-img-link');
    const isRemoveTitleLink = $gallery.getAttribute('data-remove-title-link');
    const useSrcDetails = $gallery.getAttribute('data-use-src-details');
    const priceCustomText = $gallery.getAttribute('data-price-custom-text');
    const desctopSize = $gallery.getAttribute('data-desctop-size');
    const tabletSize = $gallery.getAttribute('data-tablet-size');
    const mobileSize = $gallery.getAttribute('data-mobile-sizes');
    const gridGap = $gallery.getAttribute('data-grid-gap');
    const staticClass = $gallery.getAttribute('data-static-class');
    const imageHeight = $gallery.getAttribute('data-image-height');

    const properties = {
        listName: listName,
        isTaglineHidden:isTaglineHidden && isTaglineHidden === 'true',
        useBuiltInTitle:useBuiltInTitle && useBuiltInTitle === 'true',
        isButtonAndNoteHidden: isButtonAndNoteHidden && isButtonAndNoteHidden === 'true',
        isPriceFirstRowHidden: isPriceFirstRowHidden && isPriceFirstRowHidden === 'true',
        isPriceSecondRowHidden: isPriceSecondRowHidden && isPriceSecondRowHidden === 'true',
        isPriceThirdRowHidden: isPriceThirdRowHidden && isPriceThirdRowHidden === 'true',
        isFirstMerchRowHidden: isFirstMerchRowHidden && isFirstMerchRowHidden === 'true',
        isPriceDiscountBadgeHidden: isPriceDiscountBadgeHidden && isPriceDiscountBadgeHidden === 'true',
        isExpectedShippingHidden: isExpectedShippingHidden && isExpectedShippingHidden === 'true',
        isClockHidden: isClockHidden && isClockHidden === 'true',
        isRemoveImgLink: isRemoveImgLink && isRemoveImgLink === 'true',
        isRemoveTitleLink: isRemoveTitleLink && isRemoveTitleLink === 'true',
        useSrcDetails: useSrcDetails && useSrcDetails === 'true',
        priceCustomText: priceCustomText,
        showMoreLess: showMoreLess,
        numberOfRowsShown: (numberOfRowsShown === null || numberOfRowsShown === '' ? 9999 :  numberOfRowsShown),
        desctopSize: (desctopSize === null || desctopSize === '' ? 5 :  parseInt(desctopSize) ),
        tabletSize: (tabletSize === null || tabletSize === '' ? 3 :  parseInt(tabletSize)),
        mobileSize: (mobileSize === null || mobileSize === '' ? 2 :  parseInt(mobileSize)),
        gridGap: (gridGap === null || gridGap === '' ? 'gap-20' :  gridGap),
        staticClass: (staticClass === null || staticClass === '' ? null :  staticClass),
        isDataExplore: isDataExplore,
        dataID: dataID,
        dataType: dataType,
        dataPageType: dataPageType,
        dataTab: dataTab,
        dataCustomTitle: dataCustomTitle,
        dataCustomTitleCss: dataCustomTitleCss,
        dataCustomSubTitle: dataCustomSubTitle,
        imageHeight:imageHeight
    } as ICommonGallery;

    return properties;
};

const init = () => {
    const $placeholders = document.querySelectorAll('[data-type="course-grid-widget"]') as NodeListOf<HTMLElement>;

    for(const $gallery of $placeholders) {

        const $data = $gallery.querySelector('[data-type="course-grid-widget-data"]') as HTMLElement;
        if(!$data) continue;

        const products = getJSONFromHtml($data) as IListItem[];

        const properties = getGalleryProperties($gallery);

        sendInitialAnalytics(products, properties.listName);

        ReactDOM.render(
            <CommonProductGallery
                productGallery={ products }
                commonGalleryProps={properties}
            />,
            $gallery,
        );
    }
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});
